import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createSlots as _createSlots, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass($setup.cn('flex gap-1 p-1', $props.labelOnLeft ? 'flex-row items-start' : 'flex-col'))
    }, [
        ($setup.labelComputed || _ctx.$slots.label)
            ? (_openBlock(), _createBlock($setup["Label"], {
                key: 0,
                for: $props.staticId?.toString() || $setup.attrs.id,
                disabled: $props.disabled,
                "label-on-left": $props.labelOnLeft
            }, {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "label", {}, () => [
                        _createTextVNode(_toDisplayString($setup.labelComputed), 1 /* TEXT */)
                    ])
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["for", "disabled", "label-on-left"]))
            : _createCommentVNode("v-if", true),
        _createElementVNode("div", {
            class: _normalizeClass($setup.cn('relative flex flex-col', $props.labelOnLeft ? 'flex-1' : 'w-full'))
        }, [
            _createVNode($setup["Input"], _mergeProps($setup.attrs, {
                id: $props.staticId?.toString() || $setup.attrs.id,
                name: $props.name,
                value: $setup.modelValue ?? '',
                placeholder: $props.placeholder,
                disabled: $props.disabled,
                readonly: $props.readonly,
                required: $props.required,
                focused: $setup.isFocused,
                "has-error": !!$setup.errorMessage,
                onInput: $setup.onInput,
                onFocus: $setup.onFocus,
                onBlur: $setup.onBlur
            }), _createSlots({ _: 2 /* DYNAMIC */ }, [
                (_ctx.$slots.prepend)
                    ? {
                        name: "prepend",
                        fn: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "prepend")
                        ]),
                        key: "0"
                    }
                    : undefined,
                (_ctx.$slots.append)
                    ? {
                        name: "append",
                        fn: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "append")
                        ]),
                        key: "1"
                    }
                    : undefined
            ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["id", "name", "value", "placeholder", "disabled", "readonly", "required", "focused", "has-error"]),
            _withDirectives(_createElementVNode("p", {
                class: _normalizeClass(["text-xs top-full left-0 mt-0.5 w-full mb-0", $setup.errorMessage ? 'text-destructive' : 'text-muted-foreground'])
            }, _toDisplayString($setup.errorMessage || $props.hint), 3 /* TEXT, CLASS */), [
                [_vShow, $setup.errorMessage || $setup.showHint]
            ])
        ], 2 /* CLASS */)
    ], 2 /* CLASS */));
}
